import React from 'react';
import { Helmet } from 'react-helmet';
import BookingSection from '../components/BookingSection';
import { MapPin, Globe } from 'lucide-react';

const TransfertBruxellesParis = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Helmet>
        <title>Transfert Bruxelles Paris | Chauffeur Privé Belgique France</title>
        <meta name="description" content="Transfert privé Bruxelles Paris. Chauffeur longue distance, 3h, prix fixe. Alternative au Thalys. Service porte-à-porte." />
        <meta name="keywords" content="transfert bruxelles paris, taxi bruxelles paris, chauffeur privé paris, bruxelles france" />
        <link rel="canonical" href="https://www.luxurytransferservices.be/transfert-bruxelles-paris" />
      </Helmet>

      <section className="relative bg-gradient-to-br from-gray-900 via-black to-gray-900 py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <Globe className="w-16 h-16 text-gold mx-auto mb-6" />
            <h1 className="text-4xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-gold via-yellow-300 to-gold bg-clip-text text-transparent">
              Bruxelles ↔ Paris
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Transfert privé international Belgique - France. 3h, service premium.
            </p>
          </div>
        </div>
      </section>

      <section id="booking" className="py-12 bg-gray-900">
        <div className="container mx-auto px-4">
          <BookingSection defaultPickup="Bruxelles" defaultDropoff="Paris" />
        </div>
      </section>

      <section className="py-16 bg-gray-900">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-3xl font-bold text-gold mb-6">Transfert International Bruxelles - Paris</h2>
          <p className="text-gray-300 mb-4">
            <strong>Service de transfert premium</strong> Bruxelles → Paris. Trajet de 3h en Mercedes ou Lexus. 
            Alternative confortable au train (Thalys). Idéal pour groupes, familles, ou avec bagages volumineux. 
            Prix fixe tout inclus (péages, carburant).
          </p>
          <h3 className="text-2xl font-bold text-gold mb-4 mt-8">Avantages vs Train</h3>
          <ul className="text-gray-300 space-y-2">
            <li>✅ Porte-à-porte (pas de trajet vers/depuis gare)</li>
            <li>✅ Pas de limite de bagages</li>
            <li>✅ Horaire flexible (pas de train manqué)</li>
            <li>✅ Confort privé (pas de foule)</li>
            <li>✅ Arrêts possibles en route</li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default TransfertBruxellesParis;